// @systeme: interface
// Le SEUL endroit du client qui touche à un objet Date, et uniquement pour AFFICHER ce
// que le serveur a envoyé. Aucun calcul de date ici : « demain », « samedi », les reports
// sont décidés par le serveur (règle R2).
const FUSEAU = 'Europe/Paris';

function dateDeJour(jour: string): Date {
  const [a, m, j] = jour.split('-').map(Number);
  // Midi UTC : quel que soit le fuseau du téléphone, on reste sur le bon jour civil.
  return new Date(Date.UTC(a ?? 1970, (m ?? 1) - 1, j ?? 1, 12));
}

/** « jeudi 10 septembre » */
export function formaterJourLong(jour: string): string {
  return new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  }).format(dateDeJour(jour));
}

/** « jeu. 10 sept. » */
export function formaterJourCourt(jour: string): string {
  return new Intl.DateTimeFormat('fr-FR', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  }).format(dateDeJour(jour));
}

/** « 16h30 » depuis un instant ISO envoyé par le serveur. */
export function formaterHeure(iso: string): string {
  const parties = new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: FUSEAU,
  }).formatToParts(new Date(iso));
  const h = parties.find((p) => p.type === 'hour')?.value ?? '00';
  const m = parties.find((p) => p.type === 'minute')?.value ?? '00';
  return `${h}h${m === '00' ? '' : m}`;
}

/** Le jour civil « AAAA-MM-JJ » (Europe/Paris) d'un instant ISO, pour préremplir un sélecteur. */
export function jourDe(iso: string): string {
  const parties = new Intl.DateTimeFormat('fr-FR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: FUSEAU,
  }).formatToParts(new Date(iso));
  const v = (type: string) => parties.find((p) => p.type === type)?.value ?? '';
  return `${v('year')}-${v('month')}-${v('day')}`;
}

/** L'heure « HH:MM » (Europe/Paris) d'un instant ISO, pour préremplir un sélecteur. */
export function heureDe(iso: string): string {
  const parties = new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone: FUSEAU,
  }).formatToParts(new Date(iso));
  const v = (type: string) => parties.find((p) => p.type === type)?.value ?? '00';
  return `${v('hour')}:${v('minute')}`;
}

/** « 10 octobre 2026 » pour une date « AAAA-MM-JJ ». */
export function formaterDateComplete(jour: string): string {
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(dateDeJour(jour));
}
